/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiUserProfileFilterRequest,
  ApiUserProfilesPagedResponse,
  ConfirmEmailResponse,
  EmailConfirmationRequest,
  UpdateLanguageRequest,
  UpdateUserProfileRequest,
  UpdateUserRequest,
  UploadProfilePicturePayload,
  UserProfilePictureResponse,
  UserProfileResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiUserProfileController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name Get
   * @request GET:/api/v1/user-profile
   */
  get = (params: RequestParams = {}) =>
    this.http.request<UserProfileResponse, any>({
      path: `/v1/user-profile`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/user-profile'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name Update
   * @request PUT:/api/v1/user-profile
   */
  update = (data: UpdateUserProfileRequest, params: RequestParams = {}) =>
    this.http.request<UserProfileResponse, any>({
      path: `/v1/user-profile`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v1/user-profile'
  static updateMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name GetByUserId
   * @request GET:/api/v1/user-profile/{userId}
   */
  getByUserId = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserProfileResponse, any>({
      path: `/v1/user-profile/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByUserIdPath = '/v1/user-profile/${userId}'
  static getByUserIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name UpdateUser
   * @request PUT:/api/v1/user-profile/{userId}
   */
  updateUser = (userId: string, data: UpdateUserRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/user-profile/${userId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateUserPath = '/v1/user-profile/${userId}'
  static updateUserMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name Language
   * @request PUT:/api/v1/user-profile/language
   */
  language = (data: UpdateLanguageRequest, params: RequestParams = {}) =>
    this.http.request<UserProfileResponse, any>({
      path: `/v1/user-profile/language`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static languagePath = '/v1/user-profile/language'
  static languageMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name UploadProfilePicture
   * @request POST:/api/v1/user-profile/profile-picture
   */
  uploadProfilePicture = (data: UploadProfilePicturePayload, params: RequestParams = {}) =>
    this.http.request<UserProfilePictureResponse, any>({
      path: `/v1/user-profile/profile-picture`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadProfilePicturePath = '/v1/user-profile/profile-picture'
  static uploadProfilePictureMethod = 'POST'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name DeleteProfilePicture
   * @request DELETE:/api/v1/user-profile/profile-picture
   */
  deleteProfilePicture = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/user-profile/profile-picture`,
      method: 'DELETE',
      ...params,
    })

  static deleteProfilePicturePath = '/v1/user-profile/profile-picture'
  static deleteProfilePictureMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name GetUserProfilesPaged
   * @request POST:/api/v1/user-profile/paged
   */
  getUserProfilesPaged = (data: ApiUserProfileFilterRequest, params: RequestParams = {}) =>
    this.http.request<ApiUserProfilesPagedResponse, any>({
      path: `/v1/user-profile/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserProfilesPagedPath = '/v1/user-profile/paged'
  static getUserProfilesPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name ConfirmEmail
   * @request POST:/api/v1/user-profile/email-confirmation
   */
  confirmEmail = (data: EmailConfirmationRequest, params: RequestParams = {}) =>
    this.http.request<ConfirmEmailResponse, any>({
      path: `/v1/user-profile/email-confirmation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static confirmEmailPath = '/v1/user-profile/email-confirmation'
  static confirmEmailMethod = 'POST'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name GetEmailConfirmationEmail
   * @request GET:/api/v1/user-profile/email-confirmation/{userId}
   */
  getEmailConfirmationEmail = (userId: string, params: RequestParams = {}) =>
    this.http.request<ConfirmEmailResponse, any>({
      path: `/v1/user-profile/email-confirmation/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getEmailConfirmationEmailPath = '/v1/user-profile/email-confirmation/${userId}'
  static getEmailConfirmationEmailMethod = 'GET'
  /**
   * No description
   *
   * @tags api-user-profile-controller
   * @name GetEmailConfirmationEmailWithEmail
   * @request GET:/api/v1/user-profile/email-confirmation-with-email/{email}
   */
  getEmailConfirmationEmailWithEmail = (email: string, params: RequestParams = {}) =>
    this.http.request<ConfirmEmailResponse, any>({
      path: `/v1/user-profile/email-confirmation-with-email/${email}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getEmailConfirmationEmailWithEmailPath =
    '/v1/user-profile/email-confirmation-with-email/${email}'
  static getEmailConfirmationEmailWithEmailMethod = 'GET'
}
